export default __webpack_public_path__ + "static/media/dojang_mobile.5476c8f5.jpeg";